import type { Metadata } from "next";
import { LegalLayout, LegalSection } from "@/components/legal/legal-layout";

export const metadata: Metadata = {
  title: "Điều khoản dịch vụ",
  description: "Điều khoản sử dụng dịch vụ Tử Vi Số.",
};

export default function TermsPage() {
  return (
    <LegalLayout
      title="Điều khoản dịch vụ"
      subtitle="Khi sử dụng Tử Vi Số, bạn đồng ý với các điều khoản dưới đây."
      lastUpdated="30/05/2026"
    >
      <LegalSection title="1. Chấp nhận điều khoản">
        <p>
          Bằng việc truy cập hoặc sử dụng Tử Vi Số (gọi tắt là &ldquo;Dịch vụ&rdquo;), bạn xác nhận
          đã đọc, hiểu và đồng ý chịu sự ràng buộc của các điều khoản này. Nếu không đồng ý, vui
          lòng không sử dụng Dịch vụ.
        </p>
      </LegalSection>

      <LegalSection title="2. Mục đích Dịch vụ">
        <p>
          Tử Vi Số cung cấp các công cụ tử vi, phong thủy, lịch âm và luận giải AI dựa trên cổ học
          phương Đông. <strong>Toàn bộ kết quả chỉ mang tính tham khảo</strong>, không thay thế lời
          khuyên chuyên môn về y tế, pháp luật, tài chính, hôn nhân, hoặc giáo dục.
        </p>
      </LegalSection>

      <LegalSection title="3. Tài khoản người dùng">
        <ul className="ml-5 list-disc space-y-1.5">
          <li>Bạn phải đủ 16 tuổi và cung cấp thông tin chính xác.</li>
          <li>Bạn chịu trách nhiệm về bảo mật mật khẩu và mọi hoạt động dưới tài khoản.</li>
          <li>
            Không sử dụng tài khoản để gửi nội dung vi phạm pháp luật, quấy rối, spam, hoặc tấn công
            hệ thống.
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Sử dụng AI">
        <p>
          Tính năng luận giải AI có giới hạn số lượt theo gói (Free / Premium). Lạm dụng (gửi câu
          hỏi tự động, scrape, prompt injection) có thể dẫn đến đình chỉ tài khoản. Nội dung AI sinh
          ra không phải lời khuyên chuyên môn — bạn tự chịu trách nhiệm khi áp dụng.
        </p>
      </LegalSection>

      <LegalSection title="5. Quyền sở hữu trí tuệ">
        <p>
          Mã nguồn, thiết kế, biểu tượng, văn bản gốc thuộc về Tử Vi Số. Nội dung công thức tử vi,
          bát trạch, lịch âm là di sản cổ học công khai. Lá số bạn tạo ra thuộc về bạn — bạn được
          tải về, in, chia sẻ; không được dùng để tái phân phối thương mại nội dung do AI chúng tôi
          sinh ra.
        </p>
      </LegalSection>

      <LegalSection title="6. Giới hạn trách nhiệm">
        <p>
          Dịch vụ được cung cấp &ldquo;nguyên trạng&rdquo;. Trong phạm vi pháp luật cho phép, chúng
          tôi không chịu trách nhiệm cho thiệt hại gián tiếp phát sinh từ việc sử dụng kết quả tử
          vi, phong thủy, AI luận giải để ra quyết định cá nhân hoặc kinh doanh.
        </p>
      </LegalSection>

      <LegalSection title="7. Thay đổi điều khoản">
        <p>
          Chúng tôi có thể cập nhật điều khoản theo thời gian. Thay đổi quan trọng sẽ được thông báo
          qua email hoặc banner trên trang. Tiếp tục sử dụng Dịch vụ sau cập nhật được xem là chấp
          nhận điều khoản mới.
        </p>
      </LegalSection>

      <LegalSection title="8. Luật áp dụng">
        <p>
          Điều khoản này được điều chỉnh theo pháp luật Việt Nam. Tranh chấp giải quyết trước hết
          bằng thương lượng, nếu không đạt được thoả thuận thì thuộc thẩm quyền của Toà án Việt Nam.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
